var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiScriptDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.503 36.0758C113.25 31.5158 108.397 29 103.372 29C98.5193 29 93.667 31.5158 91.5874 36.0758L48.7829 122.558C45.8368 128.376 48.7829 135.451 55.3682 137.967C57.1012 138.753 58.8342 139.068 60.5671 139.068C65.5928 139.068 70.2718 136.552 72.5247 132.149L78.4168 120.199H128.673L134.565 132.149C136.645 136.552 141.497 139.068 146.349 139.068C148.082 139.068 149.989 138.753 151.722 137.967C158.134 135.451 161.08 128.376 158.134 122.558L115.503 36.0758ZM118.449 99.4434H88.6414L103.372 69.0961L118.449 99.4434Z",
    fill: "url(#paint0_linear_161_1035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.046 44.4096C195.046 50.6992 189.501 55.7309 182.569 55.7309C175.637 55.7309 169.918 50.6992 169.918 44.4096C169.918 38.2773 175.637 33.2456 182.569 33.2456C189.501 33.2456 195.046 38.2773 195.046 44.4096ZM182.569 139.068C174.944 139.068 168.878 133.407 168.878 126.646V72.87C168.878 66.1087 174.944 60.4481 182.569 60.4481C190.02 60.4481 196.086 66.1087 196.086 72.87V126.646C196.086 133.407 190.02 139.068 182.569 139.068Z",
    fill: "url(#paint1_linear_161_1035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9617 213.097C31.332 213.097 25.7764 211.444 22.0726 208.965C18.9244 206.852 17.9985 202.628 20.2207 199.506C22.3504 196.384 26.6097 195.557 29.7579 197.669C34.0172 200.516 42.0729 199.873 42.721 193.629C42.9988 191.516 41.9803 189.312 40.3136 188.119C38.2765 186.649 35.4061 186.557 33.1839 185.547C30.4986 184.537 27.9986 182.884 25.9615 180.864C22.1652 177.374 20.0356 172.874 19.8504 168.374C19.8504 165.803 20.3133 163.324 21.2393 160.844C22.1652 158.64 23.5541 156.62 25.2208 154.783C26.9801 153.038 28.9245 151.661 31.0542 150.651C33.4616 149.549 35.8691 148.906 38.3691 148.722C41.7951 148.63 46.8877 149.365 50.5915 151.569C53.9248 153.589 54.9434 157.722 53.0915 161.028C51.0544 164.242 46.8877 165.252 43.6469 163.324C41.3321 162.038 37.9987 162.038 35.8691 163.691C34.6654 164.609 33.832 166.17 33.832 167.64C33.6468 173.058 40.5913 173.15 44.2025 174.619C46.9803 175.813 49.5729 177.558 51.61 179.854C54.7582 183.343 56.6101 187.751 56.7027 192.527C56.8878 197.945 54.8508 202.995 50.9618 206.852C47.3507 210.526 42.3506 212.73 37.1654 213.005C36.795 213.005 36.332 213.097 35.9617 213.097Z",
    fill: "url(#paint2_linear_161_1035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4807 213.005C81.3325 213.005 78.2769 212.454 75.4991 211.261C72.7213 210.067 70.2213 208.414 68.0916 206.302C65.962 204.189 64.2953 201.71 63.0916 199.047C61.9804 196.2 61.3323 193.169 61.3323 190.047C61.3323 187.017 61.9804 183.986 63.0916 181.047C64.2953 178.384 65.962 175.997 68.0916 173.793C70.2213 171.681 72.7213 170.119 75.4991 168.926C78.2769 167.64 81.3325 167.089 84.4807 167.089C87.0733 167.089 89.5733 167.548 92.0734 168.375C94.4808 169.109 96.6105 170.303 98.5549 171.864C101.703 174.252 102.351 178.752 99.9438 181.966C98.4623 183.802 96.3327 184.813 94.1104 184.813C92.6289 184.813 91.0548 184.262 89.6659 183.251C88.1844 182.058 86.4252 181.507 84.4807 181.507C79.6658 181.507 75.8695 185.364 75.8695 190.047C75.8695 194.822 79.6658 198.588 84.4807 198.588C86.4252 198.588 88.1844 198.037 89.6659 196.843C92.9067 194.455 97.4438 195.006 99.8512 198.22C102.351 201.343 101.703 205.934 98.5549 208.322C94.5734 211.444 89.5734 213.005 84.4807 213.005Z",
    fill: "url(#paint3_linear_161_1035)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.796 167.181C126.518 167.089 126.148 167.089 125.777 167.089C122.629 167.089 119.481 167.824 116.703 169.201C115.592 167.915 113.833 167.181 111.981 167.181C108.462 167.181 105.592 170.028 105.592 173.517V205.751C105.592 209.791 108.833 213.005 112.814 213.005C116.888 213.005 120.129 209.791 120.129 205.751V187.2C120.129 184.078 122.722 181.598 125.777 181.598H126.426C130.315 181.598 133.555 178.568 133.741 174.711C133.926 170.67 130.778 167.364 126.796 167.181V167.181Z",
    fill: "url(#paint4_linear_161_1035)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.278 157.722C153.278 161.395 150.315 164.334 146.611 164.334C142.907 164.334 139.852 161.395 139.852 157.722C139.852 154.14 142.907 151.202 146.611 151.202C150.315 151.202 153.278 154.14 153.278 157.722ZM146.611 213.005C142.537 213.005 139.296 209.699 139.296 205.75V174.344C139.296 170.395 142.537 167.089 146.611 167.089C150.593 167.089 153.833 170.395 153.833 174.344V205.75C153.833 209.699 150.593 213.005 146.611 213.005Z",
    fill: "url(#paint5_linear_161_1035)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.556 166.905C179.482 166.905 175.593 168.007 172.167 169.844C171.056 168.007 169.019 166.905 166.704 166.905C163.185 166.905 160.315 169.66 160.315 173.242V220.26C160.315 224.209 163.648 227.515 167.722 227.515C171.704 227.515 175.037 224.209 175.037 220.26V211.352C177.63 212.454 180.593 213.005 183.556 213.005C196.426 213.005 206.797 202.72 206.797 189.955C206.797 177.19 196.426 166.905 183.556 166.905ZM189.667 196.016C188 197.669 185.871 198.496 183.556 198.496C181.241 198.496 179.111 197.669 177.445 196.016C175.778 194.455 174.852 192.251 174.852 189.955C174.852 187.659 175.778 185.455 177.445 183.802C179.111 182.241 181.241 181.323 183.556 181.323C185.871 181.323 188 182.241 189.667 183.802C191.334 185.455 192.26 187.659 192.26 189.955C192.26 192.251 191.334 194.455 189.667 196.016Z",
    fill: "url(#paint6_linear_161_1035)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M230.223 198.587C227.63 198.587 225.501 196.475 225.501 193.904V179.854H231.056C234.575 179.854 237.445 177.007 237.445 173.517C237.445 169.936 234.575 167.089 231.056 167.089H225.501V159.65C225.501 155.701 222.26 152.487 218.279 152.487C214.204 152.487 210.964 155.701 210.964 159.65V193.904C210.964 199.047 213.001 203.822 216.612 207.495C220.223 210.985 225.038 213.005 230.223 213.005C234.205 213.005 237.445 209.791 237.445 205.75C237.445 201.802 234.205 198.587 230.223 198.587V198.587Z",
    fill: "url(#paint7_linear_161_1035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_1035",
    x1: 47.6401,
    y1: 96.4494,
    x2: 617.892,
    y2: 96.4494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_161_1035",
    x1: 47.6402,
    y1: 96.4496,
    x2: 617.892,
    y2: 96.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_161_1035",
    x1: -67.2427,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_161_1035",
    x1: -67.2424,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_161_1035",
    x1: -67.2424,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_161_1035",
    x1: -67.2424,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_161_1035",
    x1: -67.2424,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_161_1035",
    x1: -67.2425,
    y1: 188.115,
    x2: 237.445,
    y2: 188.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82E97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21DEBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiScriptDark);
export default __webpack_public_path__ + "static/media/AiScript-Dark.78778aa52decda2c8e48e2164a8a9574.svg";
export { ForwardRef as ReactComponent };